// Module
var code = "<h2 id=\"direct-debit\">Direct Debit</h2> <p>Setting up an automatic debit is a great way to make sure your payments are on time. Check out our <a href=\"/manage/repaying-your-loan/ways-to-pay/direct-debit\">Direct Debit</a> page for more information or sign up now.</p> ";
// Exports
export default code;